import { render } from "./CopyRight.vue?vue&type=template&id=fb6f936a&scoped=true"
import script from "./CopyRight.vue?vue&type=script&lang=js"
export * from "./CopyRight.vue?vue&type=script&lang=js"

import "./CopyRight.vue?vue&type=style&index=0&id=fb6f936a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6f936a"]])

export default __exports__